























import { Component } from 'vue-property-decorator';
import profitTable from '../../components/profitTable.vue';
import charts from '../../components/echarts.vue';
import '@/component/evaluate/css/card.less';
import FinanceLoad from './finance-load';

/**
 *
 */
@Component({
    components: {
        profitTable,
        charts,
    },
})
export default class ProfitComponent extends FinanceLoad {}
